// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-and-image-container[data-v-7f572b7a]{align-items:center;padding-top:12px;padding-bottom:12px}.text-container[data-v-7f572b7a]{text-align:left;width:80%;margin-left:auto;margin-right:auto;word-break:break-word}.order-1 .text-container[data-v-7f572b7a]{margin-right:0;margin-left:auto;display:block;text-align:left}.order-2>.text-container>span[data-v-7f572b7a]{margin-left:0;display:block;text-align:left}.image-container img[data-v-7f572b7a]{width:100%}", ""]);
// Exports
module.exports = exports;
